/**
 * Theme Footer Presenter
 */
class ThemeFooterPresenter {

	constructor(sectionId) {

		this.view = new ThemeFooterView(this, sectionId);

		/*
		 * Listeners
		 */

		$(document).on(Model.LOCAL_STORAGE_AVAILABLE, $.proxy(function(_event) {
			this.view.setLocalStorageAvailable();
		}, this));

	}

}